import { render, staticRenderFns } from "./vuex-icon-checkboxes-list.vue?vue&type=template&id=2bb8bdcd&scoped=true"
import script from "./vuex-icon-checkboxes-list.vue?vue&type=script&lang=js"
export * from "./vuex-icon-checkboxes-list.vue?vue&type=script&lang=js"
import style0 from "./vuex-icon-checkboxes-list.vue?vue&type=style&index=0&id=2bb8bdcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb8bdcd",
  null
  
)

export default component.exports